<template>
	<div>
		<div @click="dealShare($event,'qqim')">qq</div>
		<div @click="dealShare($event,'weixin')">wx</div>
		<div @click="dealShare($event,'sinaminiblog')">wb</div>
	</div>
</template>

<script>
	export default{
		props: {
		  size: {
		    type: Number,
		    default: 10
		  },
		  page: {
		    type: Number,
		    default: 1
		  },
		  total: {
		    type: Number,
		    default: 0
		  }
		},
		data(){
			return{
				mypage:this.page
			}
		},
		methods: {
		  dealShare(event, type) {
		  				
		  	//console.log("type = "+type)
		  
		  	//设置分享内容
		  	bShare.addEntry({
		  		title: this.dict.title,
		  		url: location.href,
		  		summary: this.dict.forward,
		  		pic: this.netif.imagePrefix+this.dict.img_url
		  	});
		  
		  	if(type != "more"){
		  		//开始分享
		  		bShare.share(event, type, 0)
		  		return false
		  	}else{
		  		bShare.more(event);
		  		return false
		  	}
		  
		  }

		}
	}
</script>


<style>
</style>